// extracted by mini-css-extract-plugin
module.exports = {"container":"TrackingNumber_container__VerVR","imgWrapper":"TrackingNumber_imgWrapper__OjDe1","carrierImg":"TrackingNumber_carrierImg__iaxYu"};